import { MultiData, SingleData } from 'types/components/common';

export const isMultiData = <T>(value: MultiData<T> | SingleData<T>): value is MultiData<T> => {
  return Array.isArray(value);
};
